import { render, staticRenderFns } from "./fireFacilities.vue?vue&type=template&id=10f35c12&scoped=true&"
import script from "./fireFacilities.vue?vue&type=script&lang=js&"
export * from "./fireFacilities.vue?vue&type=script&lang=js&"
import style0 from "./fireFacilities.vue?vue&type=style&index=0&id=10f35c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f35c12",
  null
  
)

export default component.exports